$(function() {
  Subscription.init();
  SubscriptionOffice.init();
});

  var SubscriptionOffice = SubscriptionOffice || {};
  SubscriptionOffice = {
    init: function() {
      this.initOfficeStep1();
      this.initOfficeStep2();
      this.initOfficeStep3();
      this.initScroll();
    },
  
    initOfficeStep1: () => {
      $(document).on('click', '.js-office-product-item', function() {
        var productHandle = $(this).data('handle'),
            weeks = $(this).attr('data-shipping-interval-unit-type'),
            title = $(this).find('.js-product-title').text(),
            dataShippingFrequency = $(this).attr('data-shipping-interval-frequency'),
            days = dataShippingFrequency.split(','),
            subscriptionID = $(this).attr('data-subscription-id'),
            data_unit_type =  $(this).attr('data-shipping-interval-unit-type'),
            data_interval_frequency = $(this).attr('data-shipping-interval-frequency')
        // title = $(this).find('.js-product-title').text(),
        baseUrl = '/products/'+productHandle+'.js',
            optionValues = [],
            optionHtml = '',
            innerHtml = '',
            innerHtml2 = '',
            innerHtml3 = '';
        dataVariants = [];
        $('.js-office-product-item').removeClass('selected');
        $('.subs-desc').removeClass('selected');
        $(this).addClass('selected');
  
        $('.subscription-step__label-text').text('Select options');
        $('[data-option-dropdown]').hide();
        $('.js-your-coffee').removeClass('selected');
        $('.subscription-step__option').removeClass('selected');
        $('.js-next-step').addClass('hide');
  
        SubscriptionOffice.renderDelivered(days, weeks);
  
        $(this).parents('.subscription-step').next().removeClass('hide');
        $.getJSON(baseUrl, function(product) {
          var options = product.options;
          var variant = product.variants;
          options.map(function (option, i) {
            let isRoast = false;

            if (option.name == 'Roast' || option.name == 'roast') {
              isRoast = true;
            }
  
            variant.map(function(option, index) {
              const value = option.options[i];
              var imgUrl = '',
                  desc = '';
              if(index == 0) {
                imgUrl = subscription.roast_img_1;
                desc = subscription.roast_desc_1;
              } else {
                imgUrl = subscription.roast_img_2;
                desc = subscription.roast_desc_2;
              }
  
              if (optionValues.indexOf(value) < 0) {
                if(isRoast){
                  innerHtml2 += '<a  class="subscription-step__item swatch-item js-office-scroll-step js-office-your-coffee" data-coffee="'+value+'" data-value="'+value+'">',
                      innerHtml2 += '<div class="subscription-step__title swatch-title">'+value+'</div>';
                  innerHtml2 += '<div class="subscription-step__picture">',
                      innerHtml2 += '<img class="subscription-step__img" src="'+imgUrl+'" alt="'+value+'">',
                      innerHtml2 += '</div>',
                      innerHtml2 += '<div class="subscription-step__desc">'+desc+'</div>'
                  innerHtml2 += '</a>'
                  optionValues.push(value);
                } else {
                  innerHtml3 += '<li class="subscription-step-dropdown__item swatch-item js-recharge-dropdown-item" data-value="'+value+'" data-id="'+option.id+'"><a href="#step-4" class="subscription-step-dropdown__link js-office-scroll-step"><span class="swatch-title">'+value+'</span></a></li>';
                  optionValues.push(value);
                }
              }
            });
            $('.js-product-variants').html(innerHtml);
            $('.js-roast').html(innerHtml2);
            $('[data-option-dropdown]').html(innerHtml3);
          });
  
          dataVariants.push(variant);
  
          optionHtml += '<select class="hide" id="product-selectors-'+product.id+'" name="id">';
          variant.map(function(item) {
            optionHtml += '<option value="'+item.id+'">'+item.title+'</option>';
          });
          optionHtml += '</select>';
          $('.js-select-options').html(optionHtml);
  
          var productID = 'product-selectors-'+product.id+'';
          new Shopify.OptionSelectors(productID, {
            product: product,
            onVariantSelected: SubscriptionOffice.selectCallback
          });
          Shopify.linkOptionSelectors(product);
        });
  
        $('.js-delivered').text(title);
        $('[data-subscription-add]').attr('data-subscription-id', subscriptionID);
        $('[data-subscription-add]').attr('data-shipping-unit', data_unit_type);
        $('[data-subscription-add]').attr('data-shipping-frequency', data_interval_frequency);
      });
    },
  
    initOfficeStep2: () => {
      $(document).on('click', '.js-office-delivered-item', function() {
        var delivered = $(this).data('delivered'),
            weeks = $(this).data('weeks'),
            days = $(this).data('day');
  
        $('.js-office-delivered-item').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step').next().removeClass('hide');
  
        $('.js-delivered').text(delivered);
        $('[data-subscription-add]').attr('data-delivered', delivered).attr('data-shipping-unit', weeks).attr('data-shipping-frequency', days);
      });
    },
  
    initOfficeStep3: function() {
      $(document).on('click', '.js-office-your-coffee', function() {
        var coffee = $(this).data('coffee');
  
        $('.js-office-your-coffee').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step').next().removeClass('hide');
  
        $('.js-coffee-text').text(coffee);
      });
    },
  
    renderDelivered: function(day, weeks) {
      var days = day.map(function(item) {
        return SubscriptionOffice.buildListDelivered(item, weeks);
      });
      $('.js-recharge-days').html(days);
    },
  
    buildListDelivered: function(day, weeks) {
      var desc = '';
      if(day == '2' ) {
        desc = 'Most popular';
      }
      return [
        '<a  class="subscription-step__item js-office-delivered-item js-office-scroll-step" data-day="'+day+'" data-weeks="'+weeks+'" data-delivered="'+day+' '+weeks+'">',
        '<div class="subscription-step__title">',
        '<span class="subscription-step__title-text">Every '+day+' '+weeks+'</span>',
        '<span class="subscription-step__hint">'+desc+'</span>',
        '</div>',
        '</a>'
      ].join('');
    },
  
    selectCallback: function(variant, selector) {
      $('[data-subscription-total]').text(Shopify.formatMoney(variant.price, theme.moneyFormat));
    },
  
    initScroll: function() {
      $(document).on('click', '.js-office-scroll-step', function(e) {
        e.preventDefault();
        var hash = this.hash,
            dataStep = $(this).closest('.subscription-step').data('step'),
            maxStep = $(this).closest('.subscription__content').data('max');
  
        if (dataStep < maxStep) {
          for (i = dataStep + 1; i < maxStep; i++) {
            var stepHide = i + 1;
            $('#step-'+stepHide).addClass('hide');
  
            $('#step-'+i+' .subscription-step__item').removeClass('selected');
            $('#step-'+i+' .js-reset-label').text('Select options');
          }
        }
  
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 700)
      })
    },
  }

  // Gift subscription and Personal page optimize code
  $(document).on("ready", function(){
      for(let i=1; i<=3; i++){
        // Optimize step 1
        let selectTitleCustom = `.select-title_custom_${i}`,
            optionSelectCustom = `.option-select_custom_${i}`;
            
        $(selectTitleCustom).on("click", function(){
            $(optionSelectCustom).slideToggle();
        })

        // remove class when click outside
        $(document).mouseup(function (e) {
            if ($(e.target).closest(selectTitleCustom).length=== 0) {
                $(optionSelectCustom).hide();
            }
        }); 

        // Reset value when choose step 1
        $(`.js-tab-title_custom_${i}`).on("click", function(){
          if ($('.subscription.gift-subscription').length == 1) {
            // Handle reset value when choose step 1
            $(`.js-product-variants_custom_${i} a:first-child`).trigger("click");
            $(`.js-product-variants_custom_${i}`).hide();
            $(`.subscription-step-dropdown_custom_${i} li:first-child`).trigger("click");
            $(`.subscription-step-dropdown_custom_${i}`).hide();
            $(`.js-shipment-label_${i} .js-shipment-dropdown-item`).removeClass("active");
            $(`.js-shipment-label_${i} .js-shipment-dropdown-item:first-child`).addClass("active");
            var title_shipment = $(`.js-shipment-label_${i} .js-shipment-dropdown-item.active a`).text();
            $(`.shipment__label-text_${i}`).html(title_shipment);
            $(`.gift-subscription-data_${i}`).html(title_shipment);
          }
        })

        // Optimize step 2 (hidden)
        let selectTitleStep2 = `.select-title-option_custom_${i}`;
        let selectContentStep2 = `.select-value-option_custom_${i} .subscription-step__content_custom_${i}`;

        $(document).on('click', selectTitleStep2 , function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var $content = $(selectContentStep2);
          // Explicit show/hide avoids slideToggle race with document outside-click
          if ($content.is(':visible')) {
            $content.hide();
          } else {
            $content.show();
          }
        });

        // Close only when pointer is outside title AND outside list content
        $(document).on('click', function (e) {
          var inside = $(e.target).closest(selectTitleStep2).length || $(e.target).closest(selectContentStep2).length;
          if (!inside) {
            $(selectContentStep2).hide();
          }
        });

        // Step 2 reset value default on personal page every 2 week & 4 week
        if ($('.subscription.personal-subscription').length == 1) {
          $(`.select-value-option_custom_${i} .subscription-step__content_custom_${i} a`).on("click", function () {
            // Remove reset label choose first variant when click popup
              // $(`.select-content_custom_${i} a:first-child`).trigger("click");
              // let title_ground = $(`.js-subscription-label_custom_${i} label`).attr("data-grind");
            // $(`.subscription-step__label-text_custom_${i}`).html(title_ground);
            
          const valueToSelect = $(`.select-title-step_custom_${i} span`).text();

          const valueCoffee = $(`.subscription-step__label-text_custom_${i}`).text().trim();


          setTimeout(function () {
            $('select[data-option="option1"]').val(valueToSelect).trigger('change');
            $('select[data-option="option3"]').val(valueCoffee).trigger('change');
          }, 1000);

            
          });
        }

        // Optimize step 3
        let selectTitleStep3 = `.select-title-step_custom_${i}`,
            selectContentStep3 = `.select-content_custom_${i}`;

        $(document).on('click', selectTitleStep3 , function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var $content = $(selectContentStep3);
          if ($content.is(':visible')) {
            $content.hide();
          } else {
            $content.show();
          }
        });

        $(document).on('click', function (e) {
          var inside = $(e.target).closest(selectTitleStep3).length || $(e.target).closest(selectContentStep3).length;
          if (!inside) {
            $(selectContentStep3).hide();
          }
        });

        // Optimize step 5
        let jsSubscriptionLabel = `.js-subscription-label_custom_${i}`,
            subStepDropDown = `.subscription-step-dropdown_custom_${i}`;

        $(document).on('click', jsSubscriptionLabel, function() {
          $(subStepDropDown).slideToggle();
        });

        $(document).mouseup(function (e) {
          if ($(e.target).closest(jsSubscriptionLabel).length === 0) {
              $(subStepDropDown).hide();
          }
        }); 

      }
  })

  var Subscription = Subscription || {};
  var dataVariants = [];
  Subscription = {
    init: function() {
      // Custom popup 1
      this.initOnSubmitStep1();
      this.initOnSubmitStep2();
      this.initOnSubmitStep3();
      this.initOnSubmitStep4();
      this.initOnSubmitStep5();
      this.initOnSubmitStep6();


      // Custom popup 2
      this.initOnSubmitNewStep1();
      this.initOnSubmitNewStep2();
      this.initOnSubmitNewStep3();
      this.initOnSubmitNewStep5();

      // Custom popup 3
      this.initOnSubmitPopup_3_Step1();
      this.initOnSubmitPopup_3_Step2();
      this.initOnSubmitPopup_3_Step3();
      this.initOnSubmitPopup_3_Step5();


      this.initGiftNote();
      this.initScroll();
      this.initCloseBottomtext();
      this.dateGift();


      this.initRechargeAddToCart();
      this.initRechargeAddToCart2();
      this.initRechargeAddToCart3();

      this.datePersonal();
      this.datePersonal2();
      this.datePersonalPopup3();
    },
  
    //=======================
    initScroll: function() {
      $(document).on('click', '.js-scroll-step', function(e) {
        e.preventDefault();
        var hash = this.hash,
            dataStep = $(this).closest('.subscription-step').data('step'),
            maxStep = $(this).closest('.subscription__content').data('max');
  
        if ($('.subscription.gift-subscription').length == 1) {
          if (dataStep < maxStep) {
            for (i = dataStep + 1; i < maxStep; i++) {
              var stepHide = i + 1;
              $('#step-'+stepHide).addClass('hide');
  
              $('#step-'+i+' .subscription-step__item').removeClass('selected');
              $('#step-'+i+' .js-reset-label').text('Select options');
              $('#step-'+i+' .gift-subscription__input').val('');
              $('#step-'+i+' .gift-subscription__textarea').val('');
            }
          }
        } else {
          if (dataStep < maxStep) {
            for (i = dataStep + 1; i < maxStep; i++) {
              var stepHide = i + 1;
              $('#step-'+stepHide).addClass('hide');
  
              $('#step-'+i+' .subscription-step__item').removeClass('selected');
              $('#step-'+i+' .js-reset-label').text('Select options');
            }
          }
        }
  
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 700)
      })
    },
  
    // Custom popup step 1
    initOnSubmitStep1: () => {
      $(document).on('click', '.js-tab-title', function() {
        var tab_id = $(this).attr('data-tab'),
            title =  $.trim($(this).find('.js-subscription-title').text());

        $('.js-tab-title').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step').next().removeClass('hide');
        $('.select-title').text(title);
  
        // $('.js-next-step').addClass('hide');
        // $('[data-option-dropdown]').empty();
        // $('.js-product-variants').empty();
        // $('.js-roast').empty();

        $('.js-tab-content').hide();
        $("#"+tab_id).show();
        $('.js-recharge-title').text(title);
        var textPay = $(this).find('.subscription-step__title').text();
        var str = 'Ongoing subscription';
        if(textPay == str) {
          $('.js-reocuccr-pay').show();
          $('.js-per-delivery').show();
        } else {
          $('.js-reocuccr-pay').hide();
          $('.js-per-delivery').hide();
        }

        // For gift page
        $('.subscription.gift-subscription [data-subscription-add]').attr('data-subscription-type',title);

        // For personal page
        $('.personal-subscription [data-subscription-add]').attr('data-subscription-type',str);

        // Handle always load correct price gift  2 weeek
        if ($('.subscription.gift-subscription').length == 1) {
          $('#'+tab_id+' .js-product-item[data-shipping-interval-unit-type="Weeks"][data-shipping-interval-frequency="2"]').trigger('click');
        }
      });
    },

    initOnSubmitNewStep1: () => {
      $(document).on('click', '.js-tab-title_custom_2', function () {
        // Note data-custom need change name between popup will append data to step 2
        var tab_id = $(this).attr('data-custom'),
          title = $.trim($(this).find('.js-subscription-title_custom_2').text());


        $('.js-tab-title_custom_2').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step_custom_2').next().removeClass('hide');
        $('.select-title_custom_2').text(title);

        // $('.js-next-step').addClass('hide');
        // $('[data-option-dropdown]').empty();
        // $('.js-product-variants_custom_2').empty();
        // $('.js-roast_custom_2').empty();

        $('.js-tab-content_custom_2').hide();
        $("#" + tab_id).show();
        $('.js-recharge-title_custom_2').text(title);
        var textPay = $(this).find('.subscription-step__title_custom_2').text();
        var str = 'Ongoing subscription';
        if (textPay == str) {
          $('.js-reocuccr-pay_custom_2').show();
          $('.js-per-delivery_custom_2').show();
        } else {
          $('.js-reocuccr-pay_custom_2').hide();
          $('.js-per-delivery_custom_2').hide();
        }

        // For gift page
        $('.subscription.gift-subscription [data-subscription-add-2]').attr('data-subscription-type',title);

        // For personal page
        $('.personal-subscription [data-subscription-add-2]').attr('data-subscription-type',str);

        // Handle always load correct price gift  2 weeek
        if ($('.subscription.gift-subscription').length == 1) {
          $('#'+tab_id+' .js-product-item_custom_2[data-shipping-interval-unit-type="Weeks"][data-shipping-interval-frequency="2"]').trigger('click');
        }

      });
    },

    initOnSubmitPopup_3_Step1: () => {
      $(document).on('click', '.js-tab-title_custom_3', function () {
        var tab_id = $(this).attr('data-popup'),
            title =  $.trim($(this).find('.js-subscription-title_custom_3').text());


        $('.js-tab-title_custom_3').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step_custom_3').next().removeClass('hide');
        $('.select-title_custom_3').text(title);

        // $('.js-next-step').addClass('hide');
        // $('[data-option-dropdown]').empty();
        // $('.js-product-variants_custom_3').empty();
        // $('.js-roast_custom_3').empty();

        $('.js-tab-content_custom_3').hide();
        $("#" + tab_id).show();
        $('.js-recharge-title_custom_3').text(title);
        var textPay = $(this).find('.subscription-step__title_custom_3').text();
        var str = 'Ongoing subscription';
        if (textPay == str) {
          $('.js-reocuccr-pay_custom_3').show();
          $('.js-per-delivery_custom_3').show();
        } else {
          $('.js-reocuccr-pay_custom_3').hide();
          $('.js-per-delivery_custom_3').hide();
        }

        // For gift page
        $('.subscription.gift-subscription [data-subscription-add-3]').attr('data-subscription-type',title);

        // For personal page
        $('.personal-subscription [data-subscription-add-3]').attr('data-subscription-type',str);

        // Handle always load correct price gift  2 weeek
        if ($('.subscription.gift-subscription').length == 1) {
          $('#'+tab_id+' .js-product-item_custom_3[data-shipping-interval-unit-type="Weeks"][data-shipping-interval-frequency="2"]').trigger('click');
        }

      });
    },
    // End Custom popup step 1
  
    // Custom popup step 2
    initOnSubmitStep2: function() {
      $(document).on('click', '.js-product-item', function() {
        var productHandle = $(this).data('handle'),
            subscriptionID = $(this).attr('data-subscription-id'),
            data_unit_type =  $(this).attr('data-shipping-interval-unit-type'),
            data_interval_frequency = $(this).attr('data-shipping-interval-frequency'),
            data_selling_plan_id = $(this).attr('data-selling-plan-id'),
            title = $(this).find('.js-product-title').text(),
            baseUrl = '/products/'+productHandle+'.js',
            optionValues = [],
            optionHtml = '',
            innerHtml = '',
            innerHtml2 = '',
            innerHtml3 = '',
            delivery = $(this).data('deliverie'),
            dataVariants = [];
        
      // console.log("test base url", baseUrl)
  
      $('.js-product-item').removeClass('selected');
      $('.subs-desc').removeClass('selected');
      $(this).addClass('selected');

      $(this).parents('.select-value-option').find(".select-title-option").html(title);

      // Close frequency dropdown after selecting an option
      $(this).closest('.subscription-step__content_custom_1, .subscription-step__content').hide();

      // $('[data-option-dropdown]').hide();
      // $('.js-your-coffee').removeClass('selected');
      // $('.subscription-step__option').removeClass('selected');
  
        $(this).parents('.subscription-step').next().removeClass('hide');
        $('.js-text-delivery').text(delivery);
  
        if($('.js-text-delivery').text() == "") {
          $('.js-to-per-delivery').hide();
        } else {
          $('.js-to-per-delivery').show();
        }

        $.getJSON(baseUrl, function(product) {
          var options = product.options;
          var variant = product.variants;
          options.map(function (option, i) {
            let isWeight = false;
            let isRoast = false;
            if (option.name == 'Weight' || option.name == 'weight') {
              isWeight = true;
            }
  
            if (option.name == 'Subscription type' || option.name == 'subscription type' || option.name == 'Roast' || option.name == 'roast') {
              isRoast = true;
            }
  
            variant.map(function(option, index) {
              const value = option.options[i];
              var imgUrl = '',
                  desc = '';
              if(index == 0) {
                imgUrl = subscription.roast_img_1;
                desc = subscription.roast_desc_1;
              } else {
                imgUrl = subscription.roast_img_2;
                desc = subscription.roast_desc_2;
              }
  
              if (optionValues.indexOf(value) < 0) {
                if(isWeight) {
                  innerHtml += Subscription.buildListVariants(option, value);
                  optionValues.push(value);
                } else if(isRoast){
                  innerHtml2 += '<a href="#step-4" class="subscription-step__item swatch-item js-your-coffee" data-coffee="'+value+'" data-value="'+value+'">',
                      innerHtml2 += '<div class="subscription-step__title swatch-title">'+value+'</div>';
                  innerHtml2 += '<div class="subscription-step__picture">',
                      innerHtml2 += '<img class="subscription-step__img" src="'+imgUrl+'" alt="'+value+'">',
                      innerHtml2 += '</div>',
                      innerHtml2 += '<div class="subscription-step__desc">'+desc+'</div>'
                  innerHtml2 += '</a>'
                  optionValues.push(value);
                 
                } else {
                  var active = ""
                 
                  innerHtml3 += '<li class="subscription-step-dropdown__item swatch-item js-recharge-dropdown-item_custom_1 js-recharge-dropdown-item '+active+'" data-value="'+value+'" data-id="'+option.id+'"><a  class="subscription-step-dropdown__link"><span class="swatch-title">'+value+'</span></a></li>';
                  optionValues.push(value);
                }
              }
            });
            $('.js-product-variants').html(innerHtml);
            $('.js-roast').html(innerHtml2);
            $('[data-option-dropdown]').html(innerHtml3);
          });
  
          dataVariants.push(variant);
  
          optionHtml += '<select class="hide_" id="product-selectors-'+product.id+'" name="id">';
          variant.map(function(item) {
            optionHtml += '<option value="'+item.id+'">'+item.title+'</option>';
          });
          optionHtml += '</select>';
          $('.js-select-options').html(optionHtml);
  
          var productID = 'product-selectors-'+product.id+'';
          new Shopify.OptionSelectors(productID, {
            product: product,
            onVariantSelected: Subscription.selectCallback
          });
  
          $('.swatch-item').on('click', function() {
            var optionIndex = $(this).closest('.js-option-index').attr('data-option-index');
            var optionValue = $(this).find('.swatch-title').text();
            jQuery(this)
                .closest('.subscription__content')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
          });
          if (product.available) {
            Shopify.optionsMap = {};
            Shopify.linkOptionSelectors(product);
          }

          // Fix issues choose roating type step 4
          $('.list-popup-item-1 select[data-option="option2"]').val("Rotating Filter").trigger('change');

        });

        // $('.js-delivered').text(title);
        $('[data-subscription-add]').attr('data-subscription-id', subscriptionID);
        $('[data-subscription-add]').attr('data-shipping-unit', data_unit_type);
        $('[data-subscription-add]').attr('data-shipping-frequency', data_interval_frequency);
        $('[data-subscription-add]').attr('data-selling-plan-id', data_selling_plan_id);

        // Remove message validate step 2
        $(this).parents('.select-value-option').removeClass("errors")

      });
    },

    initOnSubmitNewStep2: function () {
        $(document).on('click', '.js-product-item_custom_2', function () {
          var productHandle = $(this).data('handle'),
            subscriptionID = $(this).attr('data-subscription-id'),
            data_unit_type = $(this).attr('data-shipping-interval-unit-type'),
            data_interval_frequency = $(this).attr('data-shipping-interval-frequency'),
            data_selling_plan_id = $(this).attr('data-selling-plan-id'),
            title = $(this).find('.js-product-title_custom_2').text(),
            baseUrl = '/products/' + productHandle + '.js',
            optionValues = [],
            optionHtml = '',
            innerHtml = '',
            innerHtml2 = '',
            innerHtml3 = '',
            delivery = $(this).data('deliverie'),
            dataVariants = [];

          $('.select-title-option_custom_2').text(title)

          // Close frequency dropdown after selecting an option
          $(this).closest('.subscription-step__content_custom_2').hide();

          $('.js-product-item_custom_2').removeClass('selected');
          $('.subs-desc_custom_2').removeClass('selected');
          $(this).addClass('selected');

          // $('[data-option-dropdown]').hide();
          // $('.js-your-coffee').removeClass('selected');
          // $('.subscription-step__option').removeClass('selected');

          //$('.js-next-step').addClass('hide');
          $(this).parents('.subscription-step_custom_2').next().removeClass('hide');
          $('.js-text-delivery_custom_2').text(delivery);

          if ($('.js-text-delivery_custom_2').text() == "") {
            $('.js-to-per-delivery_custom_2').hide();
          } else {
            $('.js-to-per-delivery_custom_2').show();
          }

          $.getJSON(baseUrl, function (product) {
            var options = product.options;
            var variant = product.variants;
            options.map(function (option, i) {
              let isWeight = false;
              let isRoast = false;
              if (option.name == 'Weight' || option.name == 'weight') {
                isWeight = true;
              }

              if (option.name == 'Subscription type' || option.name == 'subscription type') {
                isRoast = true;
              }

              variant.map(function (option, index) {
                const value = option.options[i];
                var imgUrl = '',
                  desc = '';
                if (index == 0) {
                  imgUrl = subscription.roast_img_1;
                  desc = subscription.roast_desc_1;
                } else {
                  imgUrl = subscription.roast_img_2;
                  desc = subscription.roast_desc_2;
                }

                // innerHtml += Subscription.buildListNewVariants(option, value);
                // optionValues.push(value);

                if (optionValues.indexOf(value) < 0) {
                  if (isWeight) {
                    innerHtml += Subscription.buildListNewVariants(option, value);
                    optionValues.push(value);
                  } else if (isRoast) {
                    innerHtml2 += '<a href="#step-4" class="subscription-step__item_custom_2 swatch-item_custom_2 js-scroll-step_custom_2 js-your-coffee_custom_2" data-coffee_2="' + value + '" data-value_2="' + value + '">',
                      innerHtml2 += '<div class="subscription-step__title_custom_2 swatch-title_custom_2">' + value + '</div>';
                    innerHtml2 += '<div class="subscription-step__picture">',
                      innerHtml2 += '<img class="subscription-step__img" src="' + imgUrl + '" alt="' + value + '">',
                      innerHtml2 += '</div>',
                      innerHtml2 += '<div class="subscription-step__desc">' + desc + '</div>'
                    innerHtml2 += '</a>'
                    optionValues.push(value);

                  } else {

                    var active = ""

                    innerHtml3 += '<li class="subscription-step-dropdown__item_custom_2 swatch-item_custom_2 js-recharge-dropdown-item_custom_2 '+active+'" data-value="' + value + '" data-id="' + option.id + '"><a   class="js-scroll-step_custom_2 subscription-step-dropdown__link_custom_2"><span class="swatch-title_custom_2">' + value + '</span></a></li>';
                    optionValues.push(value);
                  }
                }
              });
              $('.js-product-variants_custom_2').html(innerHtml);
              $('.js-roast_custom_2').html(innerHtml2);
              $('[data-option-dropdown_custom_2]').html(innerHtml3);
             
            });

            dataVariants.push(variant);

            optionHtml += '<select class="hide_" id="product-selectors-custom_2-' + product.id + '" name="id">';
            variant.map(function (item) {
              optionHtml += '<option value="' + item.id + '">' + item.title + '</option>';
            });
            optionHtml += '</select>';
            $('.js-select-options_custom_2').html(optionHtml);

            var productID = 'product-selectors-custom_2-' + product.id + '';


            new Shopify.OptionSelectors(productID, {
              product: product,
              onVariantSelected: Subscription.selectNewCallback
            });

            $('.swatch-item_custom_2').on('click', function () {
              var optionIndex = $(this).closest('.js-option-index_custom_2').attr('data-option-index');
              var optionValue = $(this).find('.swatch-title_custom_2').text();

              // console.log("Test value index",optionIndex )
              // console.log("Test value option", optionValue)

              // $('select[data-option="option2"]').val(valueCoffee).trigger('change');

              jQuery(this)
                .closest('.subscription__content_custom_2')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
            });
            if (product.available) {
              Shopify.optionsMap = {};
              Shopify.linkOptionSelectors(product);
            }

            // Fix issues choose roating type step 4
            $('.list-popup-item-2 select[data-option="option2"]').val("Rotating Espresso").trigger('change');

          });

          // $('.js-delivered_custom_2').text(title);
          $('[data-subscription-add-2]').attr('data-subscription-id', subscriptionID);
          $('[data-subscription-add-2]').attr('data-shipping-unit', data_unit_type);
          $('[data-subscription-add-2]').attr('data-shipping-frequency', data_interval_frequency);
          $('[data-subscription-add-2]').attr('data-selling-plan-id', data_selling_plan_id);

          // Remove message validate step 2
          $(this).parents('.select-value-option_custom_2').removeClass("errors")

        });
    },

    initOnSubmitPopup_3_Step2: function () {
      $(document).on('click', '.js-product-item_custom_3', function () {
        var productHandle = $(this).data('handle'),
          subscriptionID = $(this).attr('data-subscription-id'),
          data_unit_type = $(this).attr('data-shipping-interval-unit-type'),
          data_interval_frequency = $(this).attr('data-shipping-interval-frequency'),
          data_selling_plan_id = $(this).attr('data-selling-plan-id'),
          title = $(this).find('.js-product-title_custom_3').text(),
          baseUrl = '/products/' + productHandle + '.js',
          optionValues = [],
          optionHtml = '',
          innerHtml = '',
          innerHtml2 = '',
          innerHtml3 = '',
          delivery = $(this).data('deliverie'),
          dataVariants = [];

        // console.log("Test baseUrl 3", baseUrl)

        $('.select-title-option_custom_3').text(title)
        // Close frequency dropdown after selecting an option
        $(this).closest('.subscription-step__content_custom_3').hide();
        $('.js-product-item_custom_3').removeClass('selected');
        $('.subs-desc_custom_3').removeClass('selected');
        $(this).addClass('selected');

        // $('[data-option-dropdown]').hide();
        // $('.js-your-coffee').removeClass('selected');
        // $('.subscription-step__option').removeClass('selected');

        //$('.js-next-step').addClass('hide');
        $(this).parents('.subscription-step_custom_3').next().removeClass('hide');
        $('.js-text-delivery_custom_3').text(delivery);

        if ($('.js-text-delivery_custom_3').text() == "") {
          $('.js-to-per-delivery_custom_3').hide();
        } else {
          $('.js-to-per-delivery_custom_3').show();
        }

        $.getJSON(baseUrl, function (product) {
          var options = product.options;
          var variant = product.variants;
          options.map(function (option, i) {
            let isWeight = false;
            let isRoast = false;
            if (option.name == 'Weight' || option.name == 'weight') {
              isWeight = true;
            }

            if (option.name == 'Subscription type' || option.name == 'subscription type') {
              isRoast = true;
            }

            variant.map(function (option, index) {
              const value = option.options[i];
              var imgUrl = '',
                desc = '';
              if (index == 0) {
                imgUrl = subscription.roast_img_1;
                desc = subscription.roast_desc_1;
              } else {
                imgUrl = subscription.roast_img_2;
                desc = subscription.roast_desc_2;
              }

              if (optionValues.indexOf(value) < 0) {
                if (isWeight) {
                  innerHtml += Subscription.buildListPopup3Variants(option, value);
                  optionValues.push(value);
                } else if (isRoast) {
                  innerHtml2 += '<a href="#step-4" class="subscription-step__item_custom_3 swatch-item_custom_3 js-scroll-step_custom_3 js-your-coffee_custom_3" data-coffee_2="' + value + '" data-value_2="' + value + '">',
                  innerHtml2 += '<div class="subscription-step__title_custom_3 swatch-title_custom_3">' + value + '</div>';
                  innerHtml2 += '<div class="subscription-step__picture">',
                  innerHtml2 += '<img class="subscription-step__img" src="' + imgUrl + '" alt="' + value + '">',
                  innerHtml2 += '</div>',
                  innerHtml2 += '<div class="subscription-step__desc">' + desc + '</div>'
                  innerHtml2 += '</a>'
                  optionValues.push(value);
                
                } else {
                  var active = ""

                  innerHtml3 += '<li class="subscription-step-dropdown__item_custom_3 swatch-item_custom_3 js-recharge-dropdown-item_custom_3 '+active+'" data-value="' + value + '" data-id="' + option.id + '"><a   class="js-scroll-step_custom_3 subscription-step-dropdown__link_custom_3"><span class="swatch-title_custom_3">' + value + '</span></a></li>';
                  optionValues.push(value);
                }
              }
            });
            $('.js-product-variants_custom_3').html(innerHtml);
            $('.js-roast_custom_3').html(innerHtml2);
            $('[data-option-dropdown_custom_3]').html(innerHtml3);
           
          });

          dataVariants.push(variant);

          optionHtml += '<select class="hide_" id="product-selectors-custom_3-' + product.id + '" name="id">';
          variant.map(function (item) {
            optionHtml += '<option value="' + item.id + '">' + item.title + '</option>';
          });
          optionHtml += '</select>';
          $('.js-select-options_custom_3').html(optionHtml);

          var productID = 'product-selectors-custom_3-' + product.id + '';
          new Shopify.OptionSelectors(productID, {
            product: product,
            onVariantSelected: Subscription.selectNewCallbackPopup3
          });

          $('.swatch-item_custom_3').on('click', function () {
            var optionIndex = $(this).closest('.js-option-index_custom_3').attr('data-option-index');
            var optionValue = $(this).find('.swatch-title_custom_3').text();
            jQuery(this)
              .closest('.subscription__content_custom_3')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
          });
          if (product.available) {
            Shopify.optionsMap = {};
            Shopify.linkOptionSelectors(product);
          }

          // Fix issues choose roating type step 4
          $('.list-popup-item-3 select[data-option="option2"]').val("Brazil Espresso").trigger('change');
        });

        // $('.js-delivered_custom_3').text(title);
        $('[data-subscription-add-3]').attr('data-subscription-id', subscriptionID);
        $('[data-subscription-add-3]').attr('data-shipping-unit', data_unit_type);
        $('[data-subscription-add-3]').attr('data-shipping-frequency', data_interval_frequency);
        $('[data-subscription-add-3]').attr('data-selling-plan-id', data_selling_plan_id);

        // Remove message validate step 2
        $(this).parents('.select-value-option_custom_3').removeClass("errors")

      });
    },
    // End custom popup step 2

    // Custom popup step 3
    initOnSubmitStep3: function() {
      $(document).on('click', '.js-recharge-variant', function() {
        var variantID = $(this).data('id'),
            variantPrice = $(this).data('price'),
            dataValue = $(this).data('value');
            title = $(this).find('.js-variant-title').text();


        $(this).parents(".select-value-option-3").removeClass("active")
        $('.select-title-option3').html(`<span>${title}</span>`);
        $('.js-product-variants_custom_1, .select-content_custom_1, .js-product-variants').hide();

        
        // Handle value select step 3 4 on page gift subscription
        if ($('.subscription.gift-subscription').length == 1) {
          $('.subscription-step__label-text span.value').text("(" + title +")");
        }

        $('.js-recharge-variant').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step').next().removeClass('hide');
  
        $('.js-option-title').text(dataValue);
        // $('[data-subscription-total]').text(Shopify.formatMoney(variantPrice, theme.moneyFormat));
        $('[data-subscription-add]').attr('data-variant-id', variantID);
      })
    },

    initOnSubmitNewStep3: function() {
        $(document).on('click', '.js-recharge-variant_custom_2', function() {
            var variantID = $(this).data('id'),
                variantPrice = $(this).data('price'),
                dataValue = $(this).data('value');
            title = $(this).find('.js-variant-title_custom_2').text();

            // Custom popup 2
            $('.select-title-step_custom_2').html(`<span>${title}</span>`);
            $('.js-product-variants_custom_2, .select-content_custom_2').hide();

            // Handle value select step 3 4 on page gift subscription
            if ($('.subscription.gift-subscription').length == 1) {
              $('.subscription-step__label-text_custom_2 span.value').text("(" + title +")");
            }

            $('.js-recharge-variant_custom_2').removeClass('selected');
            $(this).addClass('selected');
            $(this).parents('.subscription-step_custom_2').next().removeClass('hide');

            $('.js-option-title_custom_2').text(dataValue);
            // $('[data-subscription-total]').text(Shopify.formatMoney(variantPrice, theme.moneyFormat));
            $('[data-subscription-add-2]').attr('data-variant-id', variantID);
        })
    },

    initOnSubmitPopup_3_Step3: function() {
        $(document).on('click', '.js-recharge-variant_custom_3', function() {
            var variantID = $(this).data('id'),
                variantPrice = $(this).data('price'),
                dataValue = $(this).data('value');
            title = $(this).find('.js-variant-title_custom_3').text();

            // Custom popup 3
            $('.select-title-step_custom_3').html(`<span>${title}</span>`);
            $('.js-product-variants_custom_3, .select-content_custom_3').hide();

            // Handle value select step 3 4 on page gift subscription
            if ($('.subscription.gift-subscription').length == 1) {
              $('.subscription-step__label-text_custom_3 span.value').text("(" + title +")");
            }

            $('.js-recharge-variant_custom_3').removeClass('selected');
            $(this).addClass('selected');
            $(this).parents('.subscription-step_custom_3').next().removeClass('hide');

            $('.js-option-title_custom_3').text(dataValue);
            // $('[data-subscription-total]').text(Shopify.formatMoney(variantPrice, theme.moneyFormat));
            $('[data-subscription-add-3]').attr('data-variant-id', variantID);
        })
    },
    // End custom popup step 3
  
    // Custom popup step 4
    initOnSubmitStep4: function() {
      $(document).on('click', '.js-your-coffee', function() {
        var coffee = $(this).data('coffee');
  
        $('.js-your-coffee').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.subscription-step').next().removeClass('hide');
  
        $('.js-coffee-text').text(coffee);
      });
    },

    // End Custom popup step 4
  
    // Custom popup step 5
    initOnSubmitStep5: function() {
      $(document).on('click', '.js-recharge-dropdown-item', function() {
        var label = $(this).attr('data-value'),
            variantID = $(this).attr('data-id'),
            text = $(this).text(),
            title_weight = $('.select-title-option3 span:first-child').text();


        $('.js-recharge-dropdown-item').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.subscription-step').next().removeClass('hide');
        $('.subscription-step__label-text').text(text);
        $('.js-recharge-label-text').text(label);
        $('[data-subscription-add]').attr('data-variant-id', variantID);

        // Handle value select step 3 4 on page gift subscription
        $('.gift-subscription .subscription-step__label-text').html(`<span class="title">${text}</span> <span class="value">(${title_weight})</span>`);

        if ($('.subscription.gift-subscription').length == 0) {
          $('.subscription-step').removeClass('hide');
          $('.subscription__action').removeClass('hide');
        }
      });

    },

    initOnSubmitNewStep5: function () {
      $(document).on('click', '.js-recharge-dropdown-item_custom_2', function () {
        var label = $(this).attr('data-value'),
          variantID = $(this).attr('data-id'),
          text = $(this).text(),
          title_weight = $('.select-title-step_custom_2 span:first-child').text();

        $('.js-recharge-dropdown-item_custom_2').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.subscription-step_custom_2').next().removeClass('hide');
        $('.subscription-step__label-text_custom_2').text(text);
        // $('.js-recharge-label-text_custom_2').text(label);
        $('[data-subscription-add-2]').attr('data-variant-id', variantID);

        
        // Handle value select step 3 4 on page gift subscription
        $('.gift-subscription .subscription-step__label-text_custom_2').html(`<span class="title">${text}</span> <span class="value">(${title_weight})</span>`);

        if ($('.subscription.gift-subscription').length == 0) {
          $('.subscription-step_custom_2').removeClass('hide');
          $('.subscription__action_custom_2').removeClass('hide');
        }
      });
    },

    initOnSubmitPopup_3_Step5: function () {
      $(document).on('click', '.js-recharge-dropdown-item_custom_3', function () {
        var label = $(this).attr('data-value'),
          variantID = $(this).attr('data-id'),
          text = $(this).text(),
          title_weight = $('.select-title-step_custom_3 span:first-child').text();


        $('.js-recharge-dropdown-item_custom_3').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.subscription-step_custom_3').next().removeClass('hide');
        $('.subscription-step__label-text_custom_3').text(text);
        $('[data-subscription-add-3]').attr('data-variant-id', variantID);

         // Handle value select step 3 4 on page gift subscription
        $('.gift-subscription .subscription-step__label-text_custom_3').html(`<span class="title">${text}</span> <span class="value">(${title_weight})</span>`);

        if ($('.subscription.gift-subscription').length == 0) {
          $('.subscription-step_custom_3').removeClass('hide');
          $('.subscription__action_custom_3').removeClass('hide');
        }
      });
    },
    // End Custom popup step 5
  
    // Custom popup step select date
    initOnSubmitStep6: function() {
      for(let i=1; i<=3; i++){
        let jsShipment = '.js-shipment-label_' + i,
            LabelShipment = '.shipment__label-text_' + i,
            giftSubData = '.gift-subscription-data_' + i;

          $(document).on('click', jsShipment, function(e) {
            $('.subscription-step__shipment').addClass('selected');
            $('.shipment-dropdown').slideToggle(200);
           
          });

          $(document).on("click",function(e){ 
            if(!$(e.target).closest('.subscription-step__shipment').length){
                $(this).removeClass('selected');
                $('.shipment-dropdown').hide();
             }
          });

          $(document).on('click', `${jsShipment} .js-shipment-dropdown-item`, function() {
            let text = $(this).text();

            $(`${jsShipment} .js-shipment-dropdown-item`).removeClass('active');
            $(this).addClass('active');
      
            $(giftSubData).text(text);
            $(LabelShipment).text(text);

            $('.gift-custom').removeClass('hide');
          });
      }
    },
    // End custom popup select date
  
    initGiftNote: function() {
      
      for (let i = 1; i <= 3; i++) {
        // console.log("Tert for performance")
      let giftTo = '#GiftTo_' + i,
          giftFrom = '#GiftFrom_' + i,
          giftRecipient = '#GiftRecipient_' + i,
          giftNotes = '#GiftNotes_' + i,
          jsGiftTo = '.js-gift-to_' + i,
          jsGiftFrom = '.js-gift-from_' + i,
          jsGiftRecipient = '.js-gift-recipient_' + i,
          jsGiftNotes = '.js-notes_' + i;

        $(giftTo).on('keyup', function() {
          let text = $(this).val();
          $(jsGiftTo).text(text);

          if($(this).val() != '') {
            $(this).parent('.gift-subscription__item').removeClass('error');
          }
          if($(giftTo).val() != '' && $(giftFrom).val() != '' && $(giftRecipient).val() != '') {
            $('#step-7').removeClass('hide');
            $('.gift-custom').removeClass('validate-input');
          } else {
            $('#step-7').addClass('hide');
            $('.gift-custom').addClass('validate-input');
          }
        });
    
        $(document).on('keyup', giftFrom, function() {
          let text = $(this).val();
          $(jsGiftFrom).text(text);
          if($(this).val() != '') {
            $(this).parent('.gift-subscription__item').removeClass('error');
          }
          if($(giftTo).val() != '' && $(giftFrom).val() != '' && $(giftRecipient).val() != '') {
            $('#step-7').removeClass('hide');
            $('.gift-custom').removeClass('validate-input');
          } else {
            $('#step-7').addClass('hide');
            $('.gift-custom').addClass('validate-input');
          }
        });
    
        $(giftTo, giftFrom,giftRecipient).on('focusout', function() {
          if($(this).val() == '') {
            $(this).parent('.gift-subscription__item').addClass('error');
          } else {
            $(this).parent('.gift-subscription__item').removeClass('error');
          }
        });

        $(giftRecipient).on('focusin', function() {
          if($(giftTo).val() == '') {
            $(giftTo).parent('.gift-subscription__item').addClass('error');
          }
          if($(giftFrom).val() == '') {
            $(giftFrom).parent('.gift-subscription__item').addClass('error');
          }
        
        });

        $(document).on('keyup', giftRecipient, function() {
          let text = $(this).val();
          $(jsGiftRecipient).text(text);

          var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
            if (testEmail.test(this.value)) {
                $('#step-7').removeClass('hide');
                $('.gift-custom').removeClass('validate-input');
                $(this).parent('.gift-subscription__item').removeClass('error');
                $(this).siblings('.gift-subscription__input-error').html("");
            }else {
                $(this).parent('.gift-subscription__item').addClass('error');
                $(this).siblings('.gift-subscription__input-error').html("Please insert a valid email address");
                $('#step-7').addClass('hide');
                $('.gift-custom').addClass('validate-input');
            }

        });

        // Validate email gift recipient
        $(document).on('blur', giftRecipient, function() {
            let testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
            if (testEmail.test(this.value)) {
                $(this).parent('.gift-subscription__item').removeClass('error');
                $('#step-7').removeClass('hide');
                $('.gift-custom').removeClass('validate-input');
            }else {
              $(this).parent('.gift-subscription__item').addClass('error');
              $(this).siblings('.gift-subscription__input-error').html("Please insert a valid email address");
                $('#step-7').addClass('hide');
                $('.gift-custom').addClass('validate-input');
            }
        });
    
        $(giftNotes).on('focusin', function() {
          if($(giftTo).val() == '') {
            $(giftTo).parent('.gift-subscription__item').addClass('error');
          }
          if($(giftFrom).val() == '') {
            $(giftFrom).parent('.gift-subscription__item').addClass('error');
          }
          if($(giftRecipient).val() == '') {
            $(giftRecipient).parent('.gift-subscription__item').addClass('error');
          }
        });
    
        $(document).on('keyup', giftNotes, function() {
          let text = $(this).val();
          $(jsGiftNotes).text(text);
        });
      }
    },
  
    initCloseBottomtext: () => {
      $(document).on('click', '.subscription-bottom__close', function() {
        sessionStorage.setItem('close', true);
        $('.subscription-bottom').slideToggle(300);
      });
  
      const getItem = sessionStorage.getItem('close');
      if (getItem) {
        $('.subscription-bottom').hide();
      }
    },
  
    // Custom popup subscription
    buildListVariants: function(item, value) {
      var text_size = '';
      if (value == '250g') {
        text_size = subscription.size_250g;
      } else if ( value == '500g') {
        text_size = subscription.size_500g;
      } else if ( value == '750g') {
        text_size = subscription.size_750g;
      } else {
        text_size = subscription.size_1kg;
      }

      // Hanlde select frency value size not change
      var select_variant = jQuery.trim(jQuery('.select-title-option3').text());

      if(value == select_variant){
        var active_value = "active"
      }else {
        var active_value = ""
      }
  
      return [
        '<a  class="subscription-step__item subs-desc swatch-item js-recharge-variant_custom_1 js-recharge-variant '+active_value+'" data-value="'+value+'" data-price="'+item.price+'" data-id="'+item.id+'">',
        '<div class="subscription-step__title swatch-title js-variant-title">',
        ''+value+'',
        '</div>',
        '<div class="subscription-step__desc">',
        '<div class="subscription-step__line">',
        '-',
        '</div>',
        text_size,
        '</div>',
        '</a>'
      ].join('');
    },

    buildListNewVariants: function (item, value) {
        var text_size = '';
        if (value == '250g') {
          text_size = subscription.size_250g;
        } else if (value == '500g') {
          text_size = subscription.size_500g;
        } else if (value == '750g') {
          text_size = subscription.size_750g;
        } else {
          text_size = subscription.size_1kg;
        }

        // Hanlde select frency value size not change
        var select_variant = jQuery.trim(jQuery('.select-title-step_custom_2').text());

        if(value == select_variant){
          var active_value = "active"
        }else {
          var active_value = ""
        }
       

        return [
          '<a  class="subscription-step__item_custom_2 subs-desc_custom_2 swatch-item_custom_2 js-scroll-step_custom_2 js-recharge-variant_custom_2 '+active_value+'" data-value="' + value + '" data-price="' + item.price + '" data-id="' + item.id + '">',
          '<div class="subscription-step__title_custom_2 swatch-title_custom_2 js-variant-title_custom_2">',
          '' + value + '',
          '</div>',
          '<div class="subscription-step__desc_custom_2">',
          '<div class="subscription-step__line_custom_2">',
          '-',
          '</div>',
          text_size,
          '</div>',
          '</a>'
        ].join('');
    },

    buildListPopup3Variants: function (item, value) {
      var text_size = '';
      if (value == '250g') {
        text_size = subscription.size_250g;
      } else if (value == '500g') {
        text_size = subscription.size_500g;
      } else if (value == '750g') {
        text_size = subscription.size_750g;
      } else {
        text_size = subscription.size_1kg;
      }

      // Hanlde select frency value size not change
      var select_variant = jQuery.trim(jQuery('.select-title-step_custom_3').text());

      if(value == select_variant){
        var active_value = "active"
      }else {
        var active_value = ""
      }

      return [
        '<a  class="subscription-step__item_custom_3 subs-desc_custom_3 swatch-item_custom_3 js-scroll-step_custom_3 js-recharge-variant_custom_3 '+active_value+'" data-value="' + value + '" data-price="' + item.price + '" data-id="' + item.id + '">',
        '<div class="subscription-step__title_custom_3 swatch-title_custom_3 js-variant-title_custom_3">',
        '' + value + '',
        '</div>',
        '<div class="subscription-step__desc_custom_3">',
        '<div class="subscription-step__line_custom_3">',
        '-',
        '</div>',
        text_size,
        '</div>',
        '</a>'
      ].join('');
    },
    // End popup subscription

    rechargeAddToCart: function(variant_id, quantity, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id) {
      if(is_gift_subscription == 'false'){
        gift_sub = 'no'
      }else {
        gift_sub = 'yes'
      }
      if ($('.subscription.gift-subscription').length == 1) {
        var gift_to = $('.js-gift-to_1').text(),
            gift_from = $('.js-gift-from_1').text(),
            gift_recipient = $('.js-gift-recipient_1').text(),
            gift_note = $('.js-notes_1').text();
  
        if (!gift_note) {
          gift_note = '';
        }
  
        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
              "subscription_type": subscription_type,
              // "shipping_frequency": frequency,
              // "shipping_unit_type": unit_type,
              // "charge_interval_frequency": frequency,
              "subscription_id": subscription_id,
              // "gift sub": gift_sub,
              "is_gift_subscription": is_gift_subscription,
              "frequency": frequency + ' ' + unit_type,
              "gift_to": gift_to,
              "gift_from": gift_from,
              "gift_recipient": gift_recipient,
              "gift_note": gift_note,
              "first_delivery": notes
          }
        }
      } else {
         var first_delivery = $('.js-first-delivery').text();

        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
            // "subscription_type": subscription_type,
            // "shipping_frequency": frequency,
            // "shipping_unit_type": unit_type,
            // "charge_interval_frequency": frequency,
            // "subscription_id": subscription_id,
            // "gift sub": gift_sub,
            "is_gift_subscription": is_gift_subscription,
            "frequency": frequency + ' ' + unit_type,
            "first_delivery": first_delivery
          }
        }
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js?_=' + Date.now(),
        data: data,
        dataType: 'json',
        cache: false,
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
          'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT'
        },
        beforeSend: function() {
          $('.sbtn-ubscription-text').hide();
          $('.icon-loader.popup_1').show();
        },
        success: function(items) {
          $('.sbtn-ubscription-text').show();
          $('.icon-loader.popup_1').hide();
          CartDrawer.getData();
          $('body').addClass('open-cart');
          if(is_gift_subscription == 'true') {
            // $('[data-subscription-add]').addClass('disabled');
            $('[data-subscription-add]').addClass('disabled_gift');
            $('[data-subscription-add-2]').addClass('disabled_gift');
            $('[data-subscription-add-3]').addClass('disabled_gift');

            // $('.gift-disabled-text').removeClass('hide');
          }
        },
        error: function (xhr) {
          $('.icon-loader.popup_1').hide();
          $('.sbtn-ubscription-text').show();
          const description = $.parseJSON(xhr.responseText).description;
          $('body').addClass('open-message');
          // $('.modal-message__error').text(description);
          $('.modal-message__error').text("Please choose delivery week again!");
          $('.select-value-option').addClass("errors");
          if(is_gift_subscription == 'false') {
            // $('[data-subscription-add]').removeClass('disabled');
            $('[data-subscription-add]').removeClass('disabled_gift');
            $('[data-subscription-add-2]').removeClass('disabled_gift');
            $('[data-subscription-add-3]').removeClass('disabled_gift');

            $('.gift-disabled-text').addClass('hide');
          }
        }
      });
    },

    rechargeAddToCart2: function(variant_id, quantity, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id) {
      if(is_gift_subscription == 'false'){
        gift_sub = 'no'
      }else {
        gift_sub = 'yes'
      }

      if ($('.subscription.gift-subscription').length == 1) {
        let gift_to = $('.js-gift-to_2').text(),
            gift_from = $('.js-gift-from_2').text(),
            gift_recipient = $('.js-gift-recipient_2').text(),
            gift_note = $('.js-notes_2').text();
  
        if (!gift_note) {
          gift_note = '';
        }
  
        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
              "subscription_type": subscription_type,
              // "shipping_frequency": frequency,
              // "shipping_unit_type": unit_type,
              // "charge_interval_frequency": frequency,
              "subscription_id": subscription_id,
              // "gift sub": gift_sub,
              "is_gift_subscription": is_gift_subscription,
              "frequency": frequency + ' ' + unit_type,
              "gift_to": gift_to,
              "gift_from": gift_from,
              "gift_recipient": gift_recipient,
              "gift_note": gift_note,
              "first_delivery": notes
          }
        }
      } else {
        var first_delivery_2 = $('.js-first-delivery_custom_2').text();

        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
            // "subscription_type": subscription_type,
            // "shipping_frequency": frequency,
            // "shipping_unit_type": unit_type,
            // "charge_interval_frequency": frequency,
            // "subscription_id": subscription_id,
            // "gift sub": gift_sub,
            "is_gift_subscription": is_gift_subscription,
            "frequency": frequency + ' ' + unit_type,
            "first_delivery": first_delivery_2
          }
        }
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js?_=' + Date.now(),
        data: data,
        dataType: 'json',
        cache: false,
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
          'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT'
        },
        beforeSend: function() {
           $('.sbtn-ubscription-text_popup_2').hide();
           $('.icon-loader.popup_2').show();
        },
        success: function(items) {
          $('.sbtn-ubscription-text_popup_2').show();
          $('.icon-loader.popup_2').hide();
          CartDrawer.getData();
          $('body').addClass('open-cart');
          if(is_gift_subscription == 'true') {
            // $('[data-subscription-add-2]').addClass('disabled');
            $('[data-subscription-add-2]').addClass('disabled_gift');
            $('[data-subscription-add]').addClass('disabled_gift');
            $('[data-subscription-add-3]').addClass('disabled_gift');

          }
        },
        error: function (xhr) {
          $('.icon-loader.popup_2').hide();
          $('.sbtn-ubscription-text_popup_2').show();
          const description = $.parseJSON(xhr.responseText).description;
          $('body').addClass('open-message');
          // $('.modal-message__error').text(description);
          $('.modal-message__error').text("Please choose delivery week again!");
          $('.select-value-option_custom_2').addClass("errors")
          if(is_gift_subscription == 'false') {
            // $('[data-subscription-add-2]').removeClass('disabled');
            $('[data-subscription-add-2]').removeClass('disabled_gift');
            $('[data-subscription-add]').removeClass('disabled_gift');
            $('[data-subscription-add-3]').removeClass('disabled_gift');

            $('.gift-disabled-text_2').addClass('hide');
          }
        }
      });
    },

    rechargeAddToCart3: function(variant_id, quantity, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id) {
      if(is_gift_subscription == 'false'){
        gift_sub = 'no'
      }else {
        gift_sub = 'yes'
      }

      if ($('.subscription.gift-subscription').length == 1) {
        let gift_to = $('.js-gift-to_3').text(),
            gift_from = $('.js-gift-from_3').text(),
            gift_recipient = $('.js-gift-recipient_3').text(),
            gift_note = $('.js-notes_3').text();
  
        if (!gift_note) {
          gift_note = '';
        }
  
        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
              "subscription_type": subscription_type,
              // "shipping_frequency": frequency,
              // "shipping_unit_type": unit_type,
              // "charge_interval_frequency": frequency,
              "subscription_id": subscription_id,
              // "gift sub": gift_sub,
              "is_gift_subscription": is_gift_subscription,
              "frequency": frequency + ' ' + unit_type,
              "gift_to": gift_to,
              "gift_from": gift_from,
              "gift_recipient": gift_recipient,
              "gift_note": gift_note,
              "first_delivery": notes
          }
        }
      } else {
        var first_delivery_3 = $('.js-first-delivery_custom_3').text();

        data = {
          'quantity': quantity,
          'id': variant_id,
          'selling_plan': selling_plan_id,
          'properties': {
            // "subscription_type": subscription_type,
            // "shipping_frequency": frequency,
            // "shipping_unit_type": unit_type,
            // "charge_interval_frequency": frequency,
            // "subscription_id": subscription_id,
            // "gift sub": gift_sub,
            "is_gift_subscription": is_gift_subscription,
            "frequency": frequency + ' ' + unit_type,
            "first_delivery": first_delivery_3
          }
        }
      }
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js?_=' + Date.now(),
        data: data,
        dataType: 'json',
        cache: false,
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
          'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT'
        },
        beforeSend: function () {
          $('.sbtn-ubscription-text_popup_3').hide();
          $('.icon-loader.popup_3').show();
        },
        success: function (items) {
          $('.sbtn-ubscription-text_popup_3').show();
          $('.icon-loader.popup_3').hide();
          CartDrawer.getData();
          $('body').addClass('open-cart');
          if (is_gift_subscription == 'true') {
            // $('[data-subscription-add-3]').addClass('disabled');
            $('[data-subscription-add]').addClass('disabled_gift');
            $('[data-subscription-add-2]').addClass('disabled_gift');
            $('[data-subscription-add-3]').addClass('disabled_gift');

          }
        },
        error: function (xhr) {
          $('.icon-loader.popup_3').hide();
          $('.sbtn-ubscription-text_popup_3').show();
          const description = $.parseJSON(xhr.responseText).description;
          $('body').addClass('open-message');
          $('.modal-message__error').text("Please choose delivery week again!");
          // $('.modal-message__error').text(description);
          $('.select-value-option_custom_3').addClass("errors")
          if (is_gift_subscription == 'false') {
            // $('[data-subscription-add-3]').removeClass('disabled');
            $('[data-subscription-add]').removeClass('disabled_gift');
            $('[data-subscription-add-2]').removeClass('disabled_gift');
            $('[data-subscription-add-3]').removeClass('disabled_gift');

            $('.gift-disabled-text_3').addClass('hide');
          }
        }
      });
    },

    initRechargeAddToCart: function() {
        $(document).on('click', '[data-subscription-add]', function() {
          if($(this).hasClass('disabled_gift')) {
            $('.gift-disabled-text').removeClass('hide');
          } else {
            var variant_id = $('.js-select-options').find('[name="id"]').val(),
                subscription_id = $(this).attr('data-subscription-id'),
                frequency = $(this).attr('data-shipping-frequency'),
                unit_type = $(this).attr('data-shipping-unit'),
                qty = 1,
                notes = $('.gift-subscription-data_1').text(),
                is_gift_subscription = $(this).attr('data-gift'),
                subscription_type = $(this).attr('data-subscription-type');
                selling_plan_id = $(this).attr('data-selling-plan-id');


            if (!notes) {
                notes = '';
            }

            if (is_gift_subscription == 'true') {
                $('[data-subscription-add]').addClass('disabled');
                // $('[data-subscription-add]').addClass('disabled_gift');
            }

            if ($('.subscription.gift-subscription').length == 1) {
                var giftTo = $('#GiftTo_1').val(),
                    giftFrom = $('#GiftFrom_1').val(),
                    giftRecipient = $('#GiftRecipient_1').val();

                if (giftTo == '') {
                    $('#GiftTo_1').parent('.gift-subscription__item').addClass('error');
                }
                if (giftFrom == '') {
                    $('#GiftFrom_1').parent('.gift-subscription__item').addClass('error');
                }

                if (giftRecipient == '') {
                    $('#GiftRecipient_1').parent('.gift-subscription__item').addClass('error');
                }

                var email_reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

                if (giftRecipient != '' && giftFrom != '' && email_reg.test(giftRecipient)) {
                    Subscription.rechargeAddToCart(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
                }
               
            } else {
                Subscription.rechargeAddToCart(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
            }
          }
        });
    },

    initRechargeAddToCart2: function() {
        $(document).on('click', '[data-subscription-add-2]', function() {
          if($(this).hasClass('disabled_gift')) {
            $('.gift-disabled-text_2').removeClass('hide');
          } else {
            var variant_id = $('.js-select-options_custom_2').find('[name="id"]').val(),
                subscription_id = $(this).attr('data-subscription-id'),
                frequency = $(this).attr('data-shipping-frequency'),
                unit_type = $(this).attr('data-shipping-unit'),
                qty = 1,
                notes = $('.gift-subscription-data_2').text(),
                is_gift_subscription = $(this).attr('data-gift'),
                subscription_type = $(this).attr('data-subscription-type');
                selling_plan_id = $(this).attr('data-selling-plan-id');

            if (!notes) {
                notes = '';
            }

            if (is_gift_subscription == 'true') {
                $('[data-subscription-add-2]').addClass('disabled');
            }

            if ($('.subscription.gift-subscription').length == 1) {
                var giftTo = $('#GiftTo_2').val(),
                    giftFrom = $('#GiftFrom_2').val(),
                    giftRecipient = $('#GiftRecipient_2').val();

                if (giftTo == '') {
                    $('#GiftTo_2').parent('.gift-subscription__item').addClass('error');
                }
                if (giftFrom == '') {
                    $('#GiftFrom_2').parent('.gift-subscription__item').addClass('error');
                }

                if (giftRecipient == '') {
                    $('#GiftRecipient_2').parent('.gift-subscription__item').addClass('error');
                }

                var email_reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

                if (giftRecipient != '' && giftFrom != '' && email_reg.test(giftRecipient)) {
                    Subscription.rechargeAddToCart2(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
                }
               
            } else {
                Subscription.rechargeAddToCart2(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
            }
          }
        });
    },

    initRechargeAddToCart3: function() {
        $(document).on('click', '[data-subscription-add-3]', function() {
          if($(this).hasClass('disabled_gift')) {
            $('.gift-disabled-text_3').removeClass('hide');
          } else {
            var variant_id = $('.js-select-options_custom_3').find('[name="id"]').val(),
                subscription_id = $(this).attr('data-subscription-id'),
                frequency = $(this).attr('data-shipping-frequency'),
                unit_type = $(this).attr('data-shipping-unit'),
                qty = 1,
                notes = $('.gift-subscription-data_3').text(),
                is_gift_subscription = $(this).attr('data-gift'),
                subscription_type = $(this).attr('data-subscription-type');
                selling_plan_id = $(this).attr('data-selling-plan-id');


            if (!notes) {
                notes = '';
            }
            if (is_gift_subscription == 'true') {
                $('[data-subscription-add-3]').addClass('disabled');
                // $('[data-subscription-add-3]').addClass('disabled_gift');
            }

            if ($('.subscription.gift-subscription').length == 1) {
                var giftTo = $('#GiftTo_3').val(),
                    giftFrom = $('#GiftFrom_3').val(),
                    giftRecipient = $('#GiftRecipient_3').val();

                if (giftTo == '') {
                    $('#GiftTo_3').parent('.gift-subscription__item').addClass('error');
                }
                if (giftFrom == '') {
                    $('#GiftFrom_3').parent('.gift-subscription__item').addClass('error');
                }

                if (giftRecipient == '') {
                    $('#GiftRecipient_3').parent('.gift-subscription__item').addClass('error');
                }

                var email_reg = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

                if (giftRecipient != '' && giftFrom != '' && email_reg.test(giftRecipient)) {
                    Subscription.rechargeAddToCart3(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
                }
            } else {
                Subscription.rechargeAddToCart3(variant_id, qty, subscription_id, frequency, unit_type, notes, is_gift_subscription, subscription_type, selling_plan_id);
            }
          }
        });
    },
  
    selectCallback: function(variant, selector) {
      if (variant) {
        $('[data-subscription-total]').text(Shopify.formatMoney(variant.price, theme.moneyFormat));
      }
    },

    selectNewCallback: function (variant, selector) {
      if (variant) {
        $('[data-subscription-total-2]').text(Shopify.formatMoney(variant.price, theme.moneyFormat));
      }
    },

    selectNewCallbackPopup3: function (variant, selector) {
      if (variant) {
        $('[data-subscription-total-3]').text(Shopify.formatMoney(variant.price, theme.moneyFormat));
      }
    },
  
    dateGift: function() {
      if ($('.js-shipment-api').length > 0) {
        var dataDate = $('.js-shipment-api').data('date');
        $.ajax({
          url:'/apps/mlc/getNextDeliveryDates?currentDate='+dataDate,
          type: 'GET',
          dataType: 'text',
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (result) {
            var resultJson = JSON.parse(result);
            resultJson.nextDeliveryDates.map(function(date){
              $('.js-shipment-api').append('<li class="shipment-dropdown__item js-shipment-dropdown-item"><a class="shipment-dropdown__link">'+date+'</a></li>')
            });
          },
          error: function(response){
            console.log('error', response);
          }
        });
      }
    },

    datePersonal: function() {
      if ($('.js-first-delivery').length > 0) {
        var dataDate = $('.js-first-delivery').data('date');
        $.ajax({
          url:'/apps/mlc/getNextDeliveryDates?currentDate='+dataDate,
          type: 'GET',
          dataType: 'text',
          headers: {
            'Content-Type': 'application/json'
          },
          success: function (result) {
            var resultJson = JSON.parse(result);
            resultJson.nextDeliveryDates.map(function(date, index){
              if (index === 0) {
                $('.js-first-delivery').html(date);
              }
            });
          },
          error: function(response){
            console.log('error', response);
          }
        });
      }
    },

    // Custom for popup 2
  datePersonal2: function () {
    if ($('.js-first-delivery_custom_2').length > 0) {
      var dataDate = $('.js-first-delivery_custom_2').data('date');
      $.ajax({
        url: '/apps/mlc/getNextDeliveryDates?currentDate=' + dataDate,
        type: 'GET',
        dataType: 'text',
        headers: {
          'Content-Type': 'application/json'
        },
        success: function (result) {
          var resultJson = JSON.parse(result);
          resultJson.nextDeliveryDates.map(function (date, index) {
            if (index === 0) {
              $('.js-first-delivery_custom_2').html(date);
            }
          });
        },
        error: function (response) {
          console.log('error', response);
        }
      });
    }
  },

  // Custom for popup 3
  datePersonalPopup3: function () {
    if ($('.js-first-delivery_custom_3').length > 0) {
      var dataDate = $('.js-first-delivery_custom_3').data('date');
      $.ajax({
        url: '/apps/mlc/getNextDeliveryDates?currentDate=' + dataDate,
        type: 'GET',
        dataType: 'text',
        headers: {
          'Content-Type': 'application/json'
        },
        success: function (result) {
          var resultJson = JSON.parse(result);
          resultJson.nextDeliveryDates.map(function (date, index) {
            if (index === 0) {
              $('.js-first-delivery_custom_3').html(date);
            }
          });
        },
        error: function (response) {
          console.log('error', response);
        }
      });
    }
  }

  }
